import { Button, Image } from 'antd';
import React, { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import { getCommonRoutePath, isIframelessVersion, isIosOrAndroid, isLoginButtonHidden, onUserImgError, } from '../../helpers/Helpers';
import { sessionStorageWrapper } from '../../helpers/storageFactory';
import InstitutionLogoHeader from '../institution-logo-header';
import { concatClsx } from 'src/helpers/classNames';
import { useAppSelector } from 'src/hooks/store';
import '../../assets/styles/custom/components/chat_header.scss';
import { NavigationTabs } from '../NavigationTabs';
var Header = function () {
    var _a, _b, _c, _d, _e, _f;
    var navigate = useNavigate();
    var account = useAppSelector(function (state) { return state.account; });
    var isMobile = useAppSelector(function (state) { return state.widget; }).isMobile;
    var page = window.location.href;
    var avatarUrl = ((_c = (_b = (_a = account.account_info) === null || _a === void 0 ? void 0 : _a.avatar) === null || _b === void 0 ? void 0 : _b.sizes) === null || _c === void 0 ? void 0 : _c['70x70']) || ((_e = (_d = account.account_info) === null || _d === void 0 ? void 0 : _d.avatar) === null || _e === void 0 ? void 0 : _e.original) || undefined;
    var goToSettings = useCallback(function () {
        sessionStorageWrapper.setItem('chatBoxGoBack', '/' + window.location.pathname.substring(window.location.pathname.indexOf('/') + 1));
        navigate(window.location.pathname.split('/')[0] + getCommonRoutePath() + '/interaction/settings');
    }, [navigate]);
    var renderExternalSpeakerTabbar = useCallback(function () {
        var _a, _b, _c, _d;
        return (React.createElement("div", { className: "chat-header-block guest-header" },
            React.createElement("div", { className: "chat-header-right-block" },
                React.createElement("div", { className: "user-block user-sa-block" },
                    ((_a = account.account_info) === null || _a === void 0 ? void 0 : _a.avatar) ? (React.createElement("img", { className: "user-avatar", src: avatarUrl, onError: onUserImgError, alt: account.account_info && account.account_info.name
                            ? account.account_info.name.slice(0, 1).toUpperCase()
                            : 'D' })) : (React.createElement("div", { className: "user-avatar user-avatar-t" }, ((_b = account.account_info) === null || _b === void 0 ? void 0 : _b.name) ? account.account_info.name.slice(0, 1).toUpperCase() : 'S')),
                    React.createElement("span", { className: "user-text" },
                        ((_c = account.account_info) === null || _c === void 0 ? void 0 : _c.name) && account.account_info.name.length > 9 && isMobile ? (React.createElement("br", null)) : null,
                        ((_d = account.account_info) === null || _d === void 0 ? void 0 : _d.name) ? account.account_info.name : 'Speaker')))));
    }, [account.account_info, avatarUrl, isMobile]);
    var isIframeLess = useMemo(function () {
        return isIframelessVersion();
    }, []);
    if (page.includes('/interaction/ambassador/sign-in')) {
        return React.createElement(React.Fragment, null);
    }
    // hides this block for webview on ambassador mob app
    if (account.isAuthFromMobApp) {
        return React.createElement(React.Fragment, null);
    }
    var commonRoutePath = getCommonRoutePath();
    if (((_f = account.account_info) === null || _f === void 0 ? void 0 : _f.key) === 'live-event-speaker') {
        return renderExternalSpeakerTabbar();
    }
    var isIosOrAndroidDevice = isIosOrAndroid();
    var hideHeader = (page.includes('/sign-in') && isIosOrAndroidDevice) || (page.includes('/sign-up') && isIosOrAndroidDevice);
    var showLoginButton = !isLoginButtonHidden();
    return (React.createElement(React.Fragment, null,
        isIframeLess && React.createElement(InstitutionLogoHeader, null),
        React.createElement("div", { className: concatClsx('guest-header m-4 flex items-center justify-between border-b border-t border-solid border-[#e8e8e8] px-0.5 py-4', hideHeader && 'hidenHeader') }, !hideHeader && (React.createElement(React.Fragment, null,
            React.createElement(NavigationTabs, null),
            !account.account_info && showLoginButton ? (React.createElement(NavLink, { end: true, to: commonRoutePath + '/interaction/sign-in', className: "block flex-shrink-0 whitespace-nowrap text-18" }, "Log in")) : null,
            account.account_info && (React.createElement("div", { className: "chat-header-right-block" },
                React.createElement(Button, { className: "user-block user-sa-block", onClick: goToSettings, "aria-label": "Settings" },
                    account.account_info.avatar ? (React.createElement(Image, { className: "user-avatar", src: avatarUrl, onError: onUserImgError, alt: account.account_info && account.account_info.name
                            ? account.account_info.name.slice(0, 1).toUpperCase()
                            : 'D' })) : (React.createElement("div", { className: "user-avatar user-avatar-t" }, account.account_info.name
                        ? account.account_info.name.slice(0, 1).toUpperCase()
                        : 'D')),
                    React.createElement("span", { className: "user-text" },
                        "Hey,",
                        account.account_info.name.length > 9 && isMobile ? React.createElement("br", null) : null,
                        account.account_info.name,
                        "!")))),
            React.createElement("a", { id: "accessibilityWidget", href: "#", tabIndex: 0, className: "block flex-shrink-0 whitespace-nowrap pl-4 text-18" }, "Accessibility"))))));
};
export default Header;
